import React, { Component } from 'react';
import { FiPlus } from 'react-icons/fi';

import BoardTile from './BoardTile/BoardTile';
import { loadBoards } from '../../services/api/api';
import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';

import '../../style/Common.css';
import '../../App.css';
import './Overview.css';

export default class SharedBoards extends Component {
  constructor() {
    super();
    this.state = {
      boards: [],
      loading: true
    };
  }

  async componentDidMount() {
    const boards = await loadBoards();
    const sharedBoards = boards.filter(board => board.role !== 'owner');

    this.setState({ boards: sharedBoards, loading: false });
  }

  renderBoards = boardCount => {
    return (
      <div className="text-center">
        {boardCount === 0 ? (
          <div>
            <div className="m-b-1">You do not have any shared Circly board yet.</div>
            <div className="m-b-3">Create a board now! </div>
            <button
              className="btn btn-primary btn-icon m-auto"
              onClick={this.props.openCreateModal}
            >
              <span className="m-r-1">
                <FiPlus size={'1.5rem'} />
              </span>
              Create new
            </button>
          </div>
        ) : (
          <div className="">
            <ul className="project-list d-flex flex-wrap">
              {this.state.boards.map(board => (
                <BoardTile board={board} key={`board-${board.id}`} />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  render() {
    const boardCount = this.state.boards.length;

    return (
      <div>
        <div className="projects-header d-flex">
          <h2>Boards shared with me</h2>
          {!this.state.loading && boardCount > 0 && (
            <button className="btn btn-primary btn-icon" onClick={this.props.openCreateModal}>
              <span className="m-r-1">
                <FiPlus size={'1.5rem'} />
              </span>
              Create new
            </button>
          )}
        </div>
        <div className="pt-2">
          {this.state.loading ? <LoadingSpinner /> : this.renderBoards(boardCount)}
        </div>
      </div>
    );
  }
}
